module.exports = __webpack_public_path__ + "static/media/hande.ad1bcf78.wav";